import { WidthContainer } from '@pata-app/ui-document';

import React from 'react';
import { Link } from 'react-router-dom';

import { NewIcon as Icon } from '../../../../components/newIcon/icon';
import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { FeatureTile } from './featureTile/featureTile';
import {
  FeatureHighlight,
  FeatureTileContent,
  FeatureTilesContainer,
  MessageCount,
  PercentageContainer,
} from './featureTile/featureTile.styled';
import { VatExclusion } from './paidFeatures.styled';

const { VITE_CDN_BASE_URL } = getEnv();

const PaidFeaturesTitle = () => {
  return (
    <TextWithHighlight>
      <h2>
        <span>Optional add-ons </span>
        for growing your pet business
      </h2>
    </TextWithHighlight>
  );
};

const PaidFeaturesSubTitle = () => {
  return (
    <p>Pata gives your pet business all it needs to take bookings, reduce no-shows and stay in touch all for free.</p>
  );
};

export function PaidFeatures() {
  return (
    <WidthContainer noBackground>
      <SectionContainer subTitle={PaidFeaturesSubTitle} title={PaidFeaturesTitle}>
        <FeatureTilesContainer>
          <FeatureTile alignment="left" image={`${VITE_CDN_BASE_URL}/images/image-person-on-iphone.jpeg`}>
            <Icon size="40px" type="TextMessage" />
            <FeatureTileContent>
              <h3>SMS notifications</h3>
              <strong>Keep clients informed with 20 free automated reminders every month</strong>
              <p>
                Need to send more? Top up your SMS balance any time and continue reaching clients for just £0.06* per
                message. simple, flexible, and no subscription required.
              </p>
            </FeatureTileContent>
          </FeatureTile>
          <FeatureTile alignment="left" image={`${VITE_CDN_BASE_URL}/images/image-person-paying-with-bank-card.jpeg`}>
            <Icon size="45px" type="Membership" />
            <FeatureTileContent>
              <h3>Payments</h3>
              <strong>Offer secure checkout and reduce no-shows with upfront payments</strong>
              <p>
                Accept deposits or full online payments and collect your clients’ card details to reduce risk with every
                booking. Processing fees start from 1.75%* + £0.45* per transaction. Learn more about PataPay.{' '}
                <Link to={'/business/pata-pay'}>{'Learn more >'}</Link>
              </p>
            </FeatureTileContent>
          </FeatureTile>
        </FeatureTilesContainer>
        <VatExclusion>
          <sup>
            <strong>*</strong>
          </sup>
          All fees are subject to VAT
        </VatExclusion>
      </SectionContainer>
    </WidthContainer>
  );
}
